import { writable } from 'svelte/store';
let state = {
    contacts: [],
    page: 0,
    total_page: 0
};
let contact = () => {
    const { subscribe, set, update } = writable(state);
    return {
        subscribe,
        update: (data) => update((store) => (Object.assign(Object.assign({}, store), data))),
        updateContact: (contacts) => update((store) => (Object.assign(Object.assign({}, store), { contacts: [
                ...store.contacts,
                ...contacts
            ] }))),
        setPage: (page) => update((store) => (Object.assign(Object.assign({}, store), { page }))),
        reset: () => update(() => (Object.assign({}, state))),
    };
};
export default contact();
